import * as React from 'react'
import cx from 'classnames'
import styles from './FormColumns.sass'

interface FormColumnsProps {
  children?: React.ReactNode
}

export function FormColumns({ children }: FormColumnsProps) {
  return <div className={cx(styles.root)}>{children}</div>
}

interface FormColumnProps {
  children?: React.ReactNode
}

export function FormColumn({ children }: FormColumnProps) {
  return <div className={cx(styles.column)}>{children}</div>
}
